module.exports = __webpack_public_path__ + "static/media/sign.0c4bd292.svg";